import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPKnowledgeDesk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 17,
	viewBox: "0 0 20 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 20,
			width: 13,
			height: 20,
			rx: 1,
			transform: "rotate(90 20 0)",
			fill: "#005AFF"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_12000_7215",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 11,
			width: 12,
			height: 6,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 11,
				width: 12,
				height: 6,
				fill: "#32C8DC"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_12000_7215)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 10,
				cy: 17,
				r: 6,
				fill: "#32C8DC"
			})
		})
	]
});
export default SvgPKnowledgeDesk;
